/**
 * NOTE: THIS FILE IS ONLY USED IN DEVELOPMENT",
 * DURING PACKAGE BUILD IT IS REGENERATED WITH ACTUAL VERSION OF THE EMCEE PACKAGE
 */

const placeholderVersion = '19.31.0';
export default placeholderVersion;
